/* global localData */
if (document.querySelector('#join-box')) {
  const joinButton = document.querySelector('#join-box .btn--accept-button');
  joinButton.addEventListener('click', (e) => {
    e.preventDefault();
    let isValid = true;
    let award = false;
    const formInfo = new FormData();
    const val = document.querySelector('#join-box input[name="radio"]:checked');
    const checkbox = document.querySelector('#join-box input[name="agreement"]:checked');
    const pwgCheckbox = document.querySelector('#join-box input[name="pwg"]');
    const program = document.querySelector('#join-box');
    const formItems = [
      {
        value: val,
        element: '.radio-button-list',
      },
      {
        value: checkbox,
        element: '.checkbox',
      },
    ];
    formItems.forEach((item) => {
      const hasValue = item.value;
      if (!hasValue) {
        isValid = false;
      }
      document.querySelector(item.element).classList.toggle('is-validation-failed', !hasValue);
    });
    if (isValid) {
      const ajax = new XMLHttpRequest();
      ajax.open('POST', localData.siteURL, true);
      formInfo.append('id', localData.id);
      formInfo.append('locationID', program.getAttribute('data-locationID'));
      formInfo.append('program', program.getAttribute('data-programID'));
      formInfo.append('id', program.getAttribute('data-user'));
      formInfo.append('action', 'createSignOnAction');
      formInfo.append('referral', val.getAttribute('id'));
      formInfo.append('redirected', val.getAttribute('redirected'));
      if (pwgCheckbox) {
        if (pwgCheckbox.checked) {
          award = true;
        }
      }
      formInfo.append('pwg', award);
      ajax.open('POST', localData.siteURL, true);
      ajax.onload = function () {
        const response = JSON.parse(ajax.responseText);
        if (response.data.status === 200) {
          window.location.href = response.data.url;
        } else {
          document.querySelector('.warning-placeholder').hidden = false;
          document.querySelector('.warning-placeholder p').innerHTML = response.data.message;
        }
      };
      ajax.send(formInfo);
    }
  });
}
